import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import { TRANSACTION_TYPES } from 'components/constants';
import Loader from 'components/Loader';
import Button from 'uikit/Button/Button';
import { CheckBox } from 'uikit/CheckBox/CheckBox';
import { CustomDatePicker } from 'uikit/CustomDatePicker';
import { InputDropDown } from 'uikit/InputDropDown/InputDropDown';
import './CounterpartiesTabTableFiltersBar.scss';

const CounterpartiesTabTableFiltersBar = ({
  isInitialized,
  isLoading,
  filters,
  handleSetFilters,
  handleGenerateMonitoringReport
}) => {
  const i18n = useContext(i18nContext);
  const currentDate = new Date();

  const directionOptions = Object.values(TRANSACTION_TYPES).map((provider) => {
    return {
      key: provider,
      value: i18n.getMessage('transactionType.' + provider)
    };
  });

  return (
    <div className={'counterparties-tab-filters-container'}>
      <div className={'counterparties-tab-actions-wrapper'}>
        <div className={'counterparties-tab-data-range-filters-wrapper'}>
          <div>
            <span>{i18n.getMessage('counterparties.tab.filter.from.label')}</span>
            <CustomDatePicker
              onChange={handleSetFilters}
              name={'from_date'}
              value={filters.from_date}
              maxDate={filters.to_date || currentDate}
            />
          </div>
          <div>
            <span>{i18n.getMessage('counterparties.tab.filter.to.label')}</span>
            <CustomDatePicker
              onChange={handleSetFilters}
              name={'to_date'}
              value={filters.to_date}
              maxDate={currentDate}
              minDate={filters.from_date}
            />
          </div>
        </div>
        <InputDropDown
          className={'counterparties-tab-filter-wrapper'}
          label={i18n.getMessage('counterparties.tab.filter.direction.label')}
          name={'direction'}
          value={filters.direction}
          options={directionOptions}
          onChange={handleSetFilters}
          isMulti
          isDisabled={isLoading}
        />
        <CheckBox
          className={'counterparties-tab-filter-checkbox'}
          name={'show_internal'}
          isActive={filters.show_internal}
          isReverseView={false}
          showCheckBox={true}
          onChange={() => handleSetFilters('show_internal', !filters.show_internal)}
          value={i18n.getMessage('counterparties.tab.filter.showInternal.label')}
          disabled={isLoading}
        />
        <Button
          className={'counterparties-tab-button'}
          roleType={'button'}
          size={'medium'}
          type={'primary'}
          onClick={handleGenerateMonitoringReport}
          isDisabled={!isInitialized || isLoading}
        >
          {isLoading ? <Loader /> : i18n.getMessage('counterparties.tab.filter.button.exportMonitoringReportCsv')}
        </Button>
      </div>
    </div>
  );
};

CounterpartiesTabTableFiltersBar.propTypes = {
  isInitialized: PropTypes.bool,
  isLoading: PropTypes.bool,
  filters: PropTypes.object,
  handleSetFilters: PropTypes.func,
  handleGenerateMonitoringReport: PropTypes.func
};

export default CounterpartiesTabTableFiltersBar;
